import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  text: {
    primary: '#2E2E2E',
    secondary: '#919191',
  },
  primary: {
    light: '#4338ca26', // main + 26
    main: '#4338ca', // indigo 700
    dark: '#3730a3', // indigo 800
    contrastText: '#FFFFFF',
  },
  primaryExtended: {
    opacityBackgroundText: '#4338ca', // main
    opacityBackgroundBackground: '#4338ca1a', // main + 1a
  },
  background: {
    default: '#FFFFFF',
    paper: '#F5F5F5',
  },
  backgroundExtended: {
    card: '#FFFFFF',
  },
  backdrop: {
    default: '#0000004D',
  },
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  error: {
    light: '#DC262626', // main + 26
    main: '#DC2626', // red 600
    dark: '#B91C1C', // red 700
    contrastText: '#FFFFFF',
  },
  warning: {
    light: '#D9770626', // main + 26
    main: '#D97706', // amber 600
    dark: '#b45309', // amber 700
    contrastText: '#FFFFFF',
  },
  info: {
    light: '#2563EB26', // main + 26
    main: '#2563EB', // blue 600
    dark: '#1D4ED8', // blue 700
    contrastText: '#FFFFFF',
  },
  success: {
    light: '#05966926', // main + 26
    main: '#059669', // emerald 600
    dark: '#047857', // emerald 700
    contrastText: '#FFFFFF',
  },
  divider: '#F0F0F0',
  grey: {
    900: '#191518',
    800: '#979797',
    700: '#A7A7A7',
    600: '#B7B7B7',
    500: '#D5D5D5',
    400: '#E2E2E2',
    300: '#EDEDED',
    200: '#F2F2F2',
    100: '#F4F4F4',
    50: '#F7F7F7',
  },
  goalImpact: {
    high: { background: '#E9E6F9', text: '#6366f1' },
    medium: { background: '#F1F5FE', text: '#a5b4fc' },
    low: { background: '#F4F4F4', text: '#e0e7ff' },
  },
};
